export const isValidFileSize = (file: File, maxSize: number): boolean => {
  // convert size to MB
  const fileSize = file.size / 1024 / 1024;

  if (fileSize > maxSize) {
    return false;
  }

  return true;
};

export const isValidFileType = (file: File, accepted: string[]): boolean => {
  return accepted.includes(file.type);
};
